export const getSelectsJustificativa = state => {
    return state.selectsJustificativa;
};
